import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _get from "lodash/get";
import { isAuthenticateAction } from "../../utils/auth";
import { updateVisitorProfile, readVisitorProfile, requestIdentity } from "../../actions"; // clear visitor data when we think the user is signed in

var shouldClearData = function shouldClearData(action) {
  return isAuthenticateAction(action) || action.type === requestIdentity.SUCCESS_TYPE;
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      _action$meta = action.meta,
      meta = _action$meta === void 0 ? {} : _action$meta,
      payload = action.payload;
  if (shouldClearData(action)) return {};

  switch (type) {
    case readVisitorProfile.SUCCESS_TYPE:
    case updateVisitorProfile.SUCCESS_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, meta.profileType, _get(payload, 'item')));

    default:
      return state;
  }
});